import React from "react";

const PulseGrowAnimation = () => (
	<style jsx>{`
    /* Safari + standard keyframes */
    @-webkit-keyframes pulse-grow {
      0%, 100% { -webkit-transform: scale(1); transform: scale(1); }
      50%      { -webkit-transform: scale(1.1); transform: scale(1.1); }
    }
    @keyframes pulse-grow {
      0%, 100% { -webkit-transform: scale(1); transform: scale(1); }
      50%      { -webkit-transform: scale(1.1); transform: scale(1.1); }
    }

    .pulse-square {
      -webkit-animation: pulse-grow 1.5s infinite ease-in-out;
              animation: pulse-grow 1.5s infinite ease-in-out;
    }
  `}</style>
);

export default function BoundingBox({
	location,
	size,
	message = "Watch this puppy!",
	hidden = false,
}) {
	if (hidden || !size.width || !size.height) return null;

	const style = {
		position: "absolute",
		top: `${location.top}px`,
		left: `${location.left}px`,
		width: `${size.width}px`,
		height: `${size.height}px`,
		pointerEvents: "none",
		zIndex: 10,
	};

    let w = size.width;

	return (
		<div className="bounding-box" style={style}>
			<PulseGrowAnimation />
			<div
				className="pulse-square w-full h-full rounded-xl"
				style={{
					boxShadow: "0 0 0 4px yellow, 0 0 0 8px cyan",
					border: "2px solid yellow",
				}}
			/>
			<div className="absolute -top-10 text-center bg-black/50 text-white font-bold rounded"
			style={{
                left: `${w / 2}px`,
                transform: "translateX(-50%)",
                whiteSpace: "nowrap",
	        }} >
				{message}
			</div>
		</div>
	);
}
